<p-toast [baseZIndex]="9999" position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5 mb-5">
    <div class="row">
      <div class="col-md-8">
        <lib-page-header-light page-title="RELATÓRIOS DE LICITAÇÕES" fa-icon="print"></lib-page-header-light>
      </div>
      <div class="col-md-4">
        <a [routerLink]="['/licitacoes']" class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </a>
        <button type="submit" (click)="gerarRelatorio()" class="btn btn-sm btn-outline-secondary float-right ml-2">
          <img src="assets/img/global/file_pdf.png" alt="cvs" title="Gerar pdf" height="20" width="20">
          Gerar PDF
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 pt-2">
        <label style="font-weight: bold; color: #757575">
          {{login.orgao.codigo}} {{login.orgao.nome}}
        </label>
      </div>
      <div class="col-md-4">
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <form>
      <div class="row mt-4">
        <div class="form-group col-md-2">
          <label for="dataInicial">Início</label>
          <input [unmask]="false" [imask]="{mask: '00/00/0000'}" [(ngModel)]="dataInicial" type="text"
            class="form-control" id="dataInicial" [ngModelOptions]="{standalone: true}">
        </div>
        <div class="form-group col-0" style="margin-top: 10px">
          <br />
          <span>à</span>
        </div>
        <div class="form-group col-md-2">
          <label for="dataFinal">&nbsp;</label>
          <input [unmask]="false" [imask]="{mask: '00/00/0000'}" [(ngModel)]="dataFinal" type="text"
            class="form-control" id="dataFinal" [ngModelOptions]="{standalone: true}">
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-6">
          <img src="assets/img/global/table_sort_filter.png" alt="img" height="22" width="22"> <span
            class="text-black-50 font-weight-light"> Filtros </span>
          <hr />
          <div class="row">
            <div class="form-group col-md-12 m-0">
              <label for="funcao">
                <div class="checkbox checbox-switch switch-primary">
                  <label>
                    <input [(ngModel)]="filtroModalidade" [ngModelOptions]="{standalone: true}" type="checkbox" />
                    <span></span>
                    Filtrar por modalidade
                  </label>
                </div>
              </label>
              <div *ngIf="filtroModalidade" class="mb-2">
                <select name="selectContrata" [(ngModel)]="modalidade" [ngModelOptions]="{standalone: true}"
                  class="custom-select">
                  <option [value]="item.id" *ngFor="let item of listaModalidade">
                    {{item.codigo}} - {{item.nome}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 m-0">
              <label for="funcao">
                <div class="checkbox checbox-switch switch-primary">
                  <label>
                    <input [(ngModel)]="filtroSituacao" [ngModelOptions]="{standalone: true}" type="checkbox" />
                    <span></span>
                    Filtrar por situação
                  </label>
                </div>
              </label>
              <div *ngIf="filtroSituacao" class="mb-2">
                <select name="selectSituacao" [(ngModel)]="situacao" [ngModelOptions]="{standalone: true}"
                  class="custom-select">
                  <option [value]="item.id" *ngFor="let item of listaSituacao">
                    {{item.nome}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 m-0">
              <label for="objeto">
                <div class="checkbox checbox-switch switch-primary">
                  <label>
                    <input [(ngModel)]="filtroObjeto" [ngModelOptions]="{standalone: true}" type="checkbox" />
                    <span></span>
                    Filtrar por objeto
                  </label>
                </div>
              </label>
              <div *ngIf="filtroObjeto" class="mb-2">
                <input id="objeto" placeholder="Descreva parte do objeto para o filtro" [(ngModel)]="objeto"
                  [ngModelOptions]="{standalone: true}" class="form-control">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 m-0">
              <label for="objeto">
                <div class="checkbox checbox-switch switch-primary">
                  <label>
                    <input [(ngModel)]="filtroValor" [ngModelOptions]="{standalone: true}" type="checkbox" />
                    <span></span>
                    Filtrar por valor estimado
                  </label>
                </div>
              </label>
              <div *ngIf="filtroValor" class="mb-2">
                <div class="row">
                  <div class="form-group col-md-4">
                    <input unmask="true" [imask]="imaskConfig" [(ngModel)]="valorInicial" type="text"
                      class="form-control" id="valorInicial" [ngModelOptions]="{standalone: true}">
                  </div>
                  <div class="form-group col-0">
                    <span>ao</span>
                  </div>
                  <div class="form-group col-md-4">
                    <input unmask="true" [imask]="imaskConfig" [(ngModel)]="valorFinal" type="text" class="form-control"
                      id="valorFinal" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <img src="assets/img/global/sort_asc_az.png" alt="img" height="22" width="22"> <span
            class="text-black-50 font-weight-light"> Ordem de impressão </span>
          <hr />
          <div class="form-row">
            <div class="col-12">
              <p-radioButton name="groupname" value="ord1" label="Número do processo" [(ngModel)]="selectedOrdem">
              </p-radioButton>
            </div>
          </div>
          <div class="form-row">
            <div class="col-12">
              <p-radioButton name="groupname" value="ord2" label="Modalidade" [(ngModel)]="selectedOrdem">
              </p-radioButton>
            </div>
          </div>
          <div class="form-row">
            <div class="col-12">
              <p-radioButton name="groupname" value="ord3" label="Data de abertura" [(ngModel)]="selectedOrdem">
              </p-radioButton>
            </div>
          </div>
          <div class="form-row">
            <div class="col-12">
              <p-radioButton name="groupname" value="ord4" label="Valor estimado" [(ngModel)]="selectedOrdem">
              </p-radioButton>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>